<c-card *transloco="let t">
  <c-card-body class="px-2" *ngIf="actions">

          <c-row>
            <c-col md="12" lg="6">
                <h1>{{ t('Lone Worker Actions Log') }}</h1>
            </c-col>
            <c-col md="12" lg="6">

              <c-row class="justify-content-end">
                <c-col xs="auto" class="mb-2" *ngIf="pagination.totalPages>1">
                  <c-input-group  class="text-end">
                    <span cInputGroupText><i class="fa-solid fa-arrow-down-1-9"></i></span>
                    <select aria-label="Default select example" name="page" cSelect (change)="updateFilter()"  [(ngModel)]="pagination.page">
                      <option *ngFor="let p of pagination.pageArray" value="{{p}}">{{p}}</option>
                    </select>
                  </c-input-group>
                </c-col>
                <c-col xs="auto" class="mb-2">
                  <c-input-group>
                    <span cInputGroupText><svg cIcon class="me-2" name="cil-sort-ascending"></svg></span>
                    <select aria-label="Default select example" (change)="updateFilter()" name="sort" cSelect [(ngModel)]="sort">
                      <option value="newest">{{ t('Newest') }}</option>
                      <option value="oldest">{{ t('Oldest') }}</option>
                      <option value="name">{{ t('Name') }}</option>
                    </select>
                  </c-input-group>
                </c-col>
                <c-col xs="auto" class="mb-2">
                  <button type="button" class="btn btn-light mb-2 me-1" aria-expanded="false" (click)="getActions()">
                    <i class="fa-solid fa-arrows-rotate"></i> {{ t('Refresh') }}
                  </button>
                  <button type="button" class="btn btn-light mb-2" aria-expanded="false" (click)="export()">
                    <i class="fa-solid fa-file-excel"></i> {{ t('Export Actions') }}
                  </button>
                </c-col>


              </c-row>

            </c-col>

          </c-row>

          <c-card class="mb-2">
            <c-card-body>


              <form cForm class="row row-cols-lg-auto g-3 align-items-center" (ngSubmit)="getActions()">
                <c-col xs="auto">
                  <label cLabel class="visually-hidden" for="search">
                    {{ t('Search') }}
                  </label>
                  <c-input-group>
                    <span cInputGroupText><svg cIcon class="me-2" name="cil-search"></svg></span>
                    <input cFormControl [(ngModel)]="search" id="search" name="search" placeholder="{{ t('Search') }}" />
                  </c-input-group>
                </c-col>

                <c-col xs="auto">
                  <c-input-group>
                    <span cInputGroupText><svg cIcon name="cil-calendar"></svg>&nbsp;&nbsp; {{ t('Dates') }}</span>
                    <input type="text" ngxDaterangepickerMd  [locale]="{format: 'DD-MM-YYYY',displayFormat: 'D MMM YYYY'}" [autoApply]="true" [closeOnAutoApply]="true" [(ngModel)]="selected" name="datetime"  class="form-control"/>

                  </c-input-group>

                </c-col>

                <c-col xs="auto">
                  <ng-select
                  [items]="okService.workers"
                  [(ngModel)]="worker_id"
                  bindLabel="name"
                  bindValue="id"
                  name="worker_id"
                  placeholder="{{ t('Worker') }}"
                  >
                  </ng-select>
                </c-col>

                <c-col xs="auto" *ngIf="!okService.isExtendedPrivacy()">
                  <ng-select
                    [items]="okService.monitors"
                    [(ngModel)]="user_id"
                    placeholder="{{ t('Monitor') }}"
                    bindLabel="name"
                    bindValue="id"
                    name="user_id"
                  >
                  </ng-select>
                </c-col>

                <c-col xs="auto" *ngIf="okService.groups.length > 0 && okService.hasFeature('groups')">
                  <ng-select
                  [items]="okService.groups"
                  [(ngModel)]="group"
                  bindLabel="name"
                  bindValue="id"
                  name="group"
                  placeholder="{{ t('Worker Group') }}"
                  >
                  </ng-select>
                </c-col>

                <c-col xs="auto">
                  <button cButton class="btn btn-light" type="submit"> {{ t('Update') }}</button>
                  &nbsp;
                  <button cButton class="btn btn-light text-danger" type="submit"  (click)="clearFilter()" *ngIf="hasFilter()">
                    <i class="fa-solid fa-xmark"></i>
                  </button>
                </c-col>
                <c-col xs="auto">

                </c-col>

                </form>

            </c-card-body>
          </c-card>


          <c-row *ngIf="actions">
            <c-col>

              <table
              [hover]="true"
              [responsive]="true"
              [striped]="true"
              align="middle"
              cTable
              class="mb-0 border"
              >
                <thead>
                  <tr>
                    <th scope="col">{{ t('Action') }}</th>
                    <th scope="col">{{ t('Date') }}</th>
                    <th scope="col">{{ t('Worker') }}</th>
                    <th scope="col">{{ t('Monitor') }}</th>
                  </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let action of actions">
                      <td>
                        <ng-container *ngIf="action.type=='action' || action.type=='message'">
                          {{action.title}}
                        </ng-container>
                        <ng-container *ngIf="action.type=='voice_message'">
                          Voice Message: <a href="{{action.information}}" target="_new">Listen Now</a>
                        </ng-container>

                      </td>
                      <td>
                        {{action.time}}
                      </td>
                      <td>
                        {{action.worker}}
                      </td>
                      <td>
                        {{action.monitor}}
                      </td>
                    </tr>
                  </tbody>

              </table>

            </c-col>
          </c-row>

  </c-card-body>
</c-card>
